// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kbqwfgmwcsasykvjvwpi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImticXdmZ213Y3Nhc3lrdmp2d3BpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQwNTA0NzksImV4cCI6MjA2OTYyNjQ3OX0.PxnlJZ7oDFV6of0t-RI8h7RJ4B0EAJuCswHLAOkxFrs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});